import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import {
  Face as FaceIcon,
  FaceRetouchingOff as FaceOffIcon,
} from '@mui/icons-material';
import { hasFaceRegistered, formatFaceRegisteredAt } from '../../utils/userFaceRecognition';

/**
 * Consistent face enrollment status for user list and detail views.
 */
const FaceRecognitionStatusChip = ({ user, size = 'small', sx }) => {
  const theme = useTheme();
  const registered = hasFaceRegistered(user);
  const registeredAt = formatFaceRegisteredAt(user);

  const tooltip = registered
    ? (registeredAt ? `Face registered on ${registeredAt}` : 'Face registered for attendance')
    : 'Face not registered — upload a profile photo when editing the user';

  return (
    <Tooltip title={tooltip} arrow>
      <Chip
        icon={registered ? <FaceIcon /> : <FaceOffIcon />}
        label={registered ? 'Face registered' : 'Not registered'}
        size={size}
        color={registered ? 'success' : 'default'}
        variant={registered ? 'filled' : 'outlined'}
        sx={{
          fontWeight: 600,
          color: registered ? theme.palette.success.contrastText : alpha(theme.palette.common.white, 0.92),
          borderColor: registered ? theme.palette.success.main : alpha(theme.palette.common.white, 0.4),
          backgroundColor: registered ? theme.palette.success.main : alpha(theme.palette.common.white, 0.08),
          '& .MuiChip-icon': {
            color: registered ? theme.palette.success.contrastText : alpha(theme.palette.common.white, 0.9),
          },
          '& .MuiChip-label': { overflow: 'visible', textOverflow: 'clip', whiteSpace: 'nowrap' },
          ...sx,
        }}
      />
    </Tooltip>
  );
};

export default FaceRecognitionStatusChip;
